import React from 'react';
import { useAppSelector } from '../data/store';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

const LoggedOut = () => {
    const showNewUserPopup = useAppSelector(store => store.root.showNewUserPopup);

    return (
        <section className="text-center mb-2">
            <p className="flex justify-center">
                <a
                    href="/login"
                    title=""
                    className="w-btn w-auto max-auto mb-2 mt-2"
                    onClick={ () => {
                        sendGAEvent('Top Mini Account', 'Sign in');
                    }}>Sign In</a>
            </p>

            <p className={ showNewUserPopup ? '' : 'mb-4' }>
                New user? <a href="/create-account" title="" onClick={ () => {
                    sendGAEvent('Top Mini Account', 'Create Account');
                }}>Start here</a>
            </p>
        </section>
    )
};

export default LoggedOut;